module.exports = __webpack_public_path__ + "media/slider/Banner-0-efc4a0b5.jpg";